
import { computed, defineComponent, inject } from "vue";
import DateRange from "@/components/typography/DateRange.vue";
//import Dropdown1 from "@/components/dropdown/Dropdown1.vue";
import { toolbarWidthFluid } from "@/core/helpers/config";
import { useRoute } from "vue-router";
// import ActivityModal from "@/views/user/modal/ActivityModal.vue";
import { TranslationService } from "@/core/services/TranslationService";
import { Emitter } from "mitt";
type refreshDashboard = {
  refreshDashboard: boolean;
};
export default defineComponent({
  name: "KToolbar",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  components: {
    //Dropdown1,
    DateRange,
    // ActivityModal,
  },
  setup() {
    const route = useRoute();
    const emitter: Emitter<refreshDashboard> | undefined = inject("emitter");
    const routerName = computed(() => {
      return route.name as string;
    });
    const selectedActivity = computed(() => {
      return routerName.value == "locations"
        ? {
            title: "Locations Activity Pulse",
            type: "2600,1700,1500",
          }
        : routerName.value == "site"
        ? { title: "Branches Activity Pulse", type: "200,1100,1600,1500,2100" }
        : routerName.value == "form.definition"
        ? {
            title: "Forms Activity Pulse",
            type: "100,700,2700,1600,2000,1900,1800",
          }
        : routerName.value == "sections"
        ? {
            title: "Sections Activity Pulse",
            type: "2700,600",
          }
        : routerName.value == "user"
        ? {
            title: "Users Activity Pulse",
            type: "300,1400,1100,2000,2300",
          }
        : routerName.value == "roles"
        ? {
            title: "Roles Activity Pulse",
            type: "1200,1900,2200",
          }
        : routerName.value == "user.permission"
        ? {
            title: "User Permissions Activity Pulse",
            type: "2300",
          }
        : routerName.value == "eventManagement"
        ? {
            title: "Events Activity Pulse",
            type: "1000,1800,2900",
          }
        : routerName.value == "email"
        ? {
            title: "Emails Activity Pulse",
            type: "2800",
          }
        : routerName.value == "devices"
        ? {
            title: "Devices Activity Pulse",
            type: "400,1500",
          }
        : null;
    });
    const isDateRangeComponent = computed(() => {
      return (
        routerName.value &&
        [
          "branch-dashboard",
          "form-dashboard",
          "user-dashboard",
          "dashboard",
        ].includes(routerName.value)
      );
    });
    const isActivityComponent = computed(() => {
      return (
        routerName.value &&
        [
          "locations",
          "site",
          "form.definition",
          "sections",
          "user",
          "roles",
          "user.permission",
          "eventManagement",
          "email",
          "devices",
        ].includes(routerName.value)
      );
    });
    const isHomeLayout = computed(() => {
      return routerName.value && routerName.value.includes("home");
    });
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    return {
      toolbarWidthFluid,
      isDateRangeComponent,
      isHomeLayout,
      t,
      isActivityComponent,
      routerName,
      selectedActivity,
      emitter,
    };
  },
});
